module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921112649_T.b49ebbdb.jpg";